var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-card",
    { attrs: { elevation: "0" } },
    [
      _c(
        "v-card-actions",
        { staticClass: "ma-0 pa-0" },
        [
          _c("v-text-field", {
            attrs: {
              "hide-details": "",
              type: "number",
              outlined: "",
              dense: "",
              rules: [_vm.rules.value],
            },
            model: {
              value: _vm._min[0],
              callback: function ($$v) {
                _vm.$set(_vm._min, 0, $$v)
              },
              expression: "_min[0]",
            },
          }),
          _c("v-card", { staticClass: "ma-1", attrs: { elevation: "0" } }, [
            _vm._v("."),
          ]),
          _c("v-text-field", {
            attrs: {
              "hide-details": "",
              type: "number",
              outlined: "",
              dense: "",
              rules: [_vm.rules.value],
            },
            model: {
              value: _vm._min[1],
              callback: function ($$v) {
                _vm.$set(_vm._min, 1, $$v)
              },
              expression: "_min[1]",
            },
          }),
          _c("v-card", { staticClass: "ma-1", attrs: { elevation: "0" } }, [
            _vm._v("."),
          ]),
          _c("v-text-field", {
            attrs: {
              "hide-details": "",
              type: "number",
              outlined: "",
              dense: "",
              rules: [_vm.rules.value],
            },
            model: {
              value: _vm._min[2],
              callback: function ($$v) {
                _vm.$set(_vm._min, 2, $$v)
              },
              expression: "_min[2]",
            },
          }),
          _c("v-card", { staticClass: "ma-1", attrs: { elevation: "0" } }, [
            _vm._v("-"),
          ]),
          _c("v-text-field", {
            attrs: {
              "hide-details": "",
              type: "number",
              outlined: "",
              dense: "",
              rules: [_vm.rules.value],
            },
            model: {
              value: _vm._max[0],
              callback: function ($$v) {
                _vm.$set(_vm._max, 0, $$v)
              },
              expression: "_max[0]",
            },
          }),
          _c("v-card", { staticClass: "ma-1", attrs: { elevation: "0" } }, [
            _vm._v("."),
          ]),
          _c("v-text-field", {
            attrs: {
              "hide-details": "",
              type: "number",
              outlined: "",
              dense: "",
              rules: [_vm.rules.value],
            },
            model: {
              value: _vm._max[1],
              callback: function ($$v) {
                _vm.$set(_vm._max, 1, $$v)
              },
              expression: "_max[1]",
            },
          }),
          _c("v-card", { staticClass: "ma-1", attrs: { elevation: "0" } }, [
            _vm._v("."),
          ]),
          _c("v-text-field", {
            attrs: {
              "hide-details": "",
              type: "number",
              outlined: "",
              dense: "",
              rules: [_vm.rules.value],
            },
            model: {
              value: _vm._max[2],
              callback: function ($$v) {
                _vm.$set(_vm._max, 2, $$v)
              },
              expression: "_max[2]",
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }